var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[_c('div',{staticClass:"cell text-center"},[_c('div',{staticStyle:{"width":"250px","display":"inline-block"}},[_c('el-button',{staticClass:"short inline-block",on:{"click":function($event){return _vm.runFix()}}},[_vm._v(" 저장 ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }